import api from '@pray/shared/utils/api';

export async function deleteRssFeed({ artistId, rssFeedId }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!rssFeedId) throw Error('RSS Feed ID is required');

  const url = `/web/studio/artists/${artistId}/rss-feeds/${rssFeedId}`;
  const response = await api.executeDeleteRequest(url);

  return response.data.data;
}
